export default "__VITE_ASSET__DWb8vjbA__"